var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftGridImageMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 594,
    viewBox: "0 0 548 594",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1405_22996)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 388.74,
    cy: 455.108,
    rx: 68.5043,
    ry: 145.347,
    transform: "rotate(124.141 388.74 455.108)",
    fill: "url(#paint0_linear_1405_22996)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 42.4297,
    y1: 10.2266,
    x2: 42.4297,
    y2: 506.871,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.0938,
    y1: 0.0664063,
    x2: 84.0937,
    y2: 506.872,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.766,
    y1: 0.0664063,
    x2: 125.766,
    y2: 506.872,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.43,
    y1: 0.0664063,
    x2: 167.43,
    y2: 506.872,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.094,
    y1: 0.0664063,
    x2: 209.094,
    y2: 506.872,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.766,
    y1: 0.0664063,
    x2: 250.766,
    y2: 506.872,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.43,
    y1: 0.0664063,
    x2: 292.43,
    y2: 506.872,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.094,
    y1: 0.0664063,
    x2: 334.094,
    y2: 506.872,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.766,
    y1: 0.0664063,
    x2: 375.766,
    y2: 506.872,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.43,
    y1: 0.0664063,
    x2: 417.43,
    y2: 506.872,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.094,
    y1: 0.0664063,
    x2: 459.094,
    y2: 506.872,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 40.3516,
    x2: -0.00366215,
    y2: 40.3515,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 82.7812,
    x2: -0.00366215,
    y2: 82.7812,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 125.215,
    x2: -0.00366215,
    y2: 125.215,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 167.648,
    x2: -0.00366215,
    y2: 167.648,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 210.078,
    x2: -0.00366215,
    y2: 210.078,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 252.512,
    x2: -0.00366215,
    y2: 252.512,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 294.941,
    x2: -0.00366215,
    y2: 294.941,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 337.375,
    x2: -0.00366215,
    y2: 337.375,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 379.805,
    x2: -0.00366215,
    y2: 379.805,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 422.238,
    x2: -0.00366215,
    y2: 422.238,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.523,
    y1: 464.672,
    x2: -0.00366215,
    y2: 464.672,
    stroke: "#7551FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "left-grid-star"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.351 155.853C427.422 155.257 428.287 155.257 428.358 155.853L428.951 160.853C429.717 167.309 434.807 172.398 441.263 173.164L446.262 173.758C446.858 173.828 446.858 174.693 446.262 174.764L441.263 175.357C434.807 176.123 429.717 181.213 428.951 187.669L428.358 192.668C428.287 193.265 427.422 193.265 427.351 192.668L426.758 187.669C425.992 181.213 420.902 176.123 414.447 175.357L409.447 174.764C408.851 174.693 408.851 173.828 409.447 173.758L414.447 173.164C420.902 172.398 425.992 167.309 426.758 160.853L427.351 155.853Z",
    fill: "#7551FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1405_22996",
    x: 260.609,
    y: 353.953,
    width: 256.258,
    height: 202.313,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.902389,
    result: "effect1_foregroundBlur_1405_22996"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1405_22996",
    x1: 343.382,
    y1: 325.398,
    x2: 402.541,
    y2: 598.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF9FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftGridImageMobile);
export default __webpack_public_path__ + "static/media/LeftGridImageMobile.4f210fd7e5529eeb5c7f4613d2811574.svg";
export { ForwardRef as ReactComponent };